// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1ygA5","list":"BalanceDue_list__1NjT1","listRow":"BalanceDue_listRow__1IcA-","total":"BalanceDue_total__1xaCu"};